var ItemExtras = React.createClass({

  render: function(){
    var item = this.props.item;

    function float_to_time(f){
      var raw = f / 3600000000000,
          hours = raw | 0,
          minutes = (raw - hours) * 60,
          hourSuffix = hours > 1 ? "s" : "",
          minuteSuffix = minutes > 1 ? "s": "";

      return raw; //(hours > 0 ? hours + " hour" + hourSuffix + " ": "") + (minutes > 0 ? minutes + " minute" + minuteSuffix : "");
    }

    function build_extra_segment(label, value, iconUrl){
      if (!label && !value) return ""

      var labelTag = (label === null ? null : <span className='extras-duration-label'>{ label } </span>),
          valueTag = (value === null ? "" : <span className='extras-duration-value'>{ value }</span>);

      return (
          <li>
            <span className="extras-icon-wrapper"><img src={ "/images/" + iconUrl } /></span>
            { labelTag }
            { valueTag }
          </li>
      )
    } 

    var today = new Date().getDay(),
        destinationName = item.destination.replace(/-/g, " ");

    if (item.weekday_hours && item.weekday_hours.periods && item.weekday_hours.periods[today]){
      var opening = moment(item.weekday_hours.periods[today].open.time, "HHmm").format("h:mm a"),
          closing = moment(item.weekday_hours.periods[today].close.time, "HHmm").format("h:mm a");
    
      var timeLabel = "Today:",
          timeValue = opening + " - " + closing;
    } else {
      var timeLabel = null,
          timeValue = null;
    }

    if (!!item.tags){ 
      var tags = Array.isArray(item.tags) ? item.tags : item.tags.split(","),
          tagString = !!item.tags ? tags.filter(function(t){ return !(new RegExp(destinationName + "|Attraction", "gi").test(t)) }).join(", ") : null
    } else {
      var tagString = null;
    }

    return (
      <div className={ "item-extras" }>
        <div className="extras-duration">
          <ul>
            { build_extra_segment(timeLabel, timeValue, "hours.png") }
            { build_extra_segment("Length of Stay: *", float_to_time(item.duration_min) + " - " + float_to_time(item.duration_max) + " hrs", "duration.png") }
            { build_extra_segment(null, tagString, "tag.png") }
          </ul>
        </div>
      </div>
    );
  }
});

module.exports = ItemExtras;


// WEBPACK FOOTER //
// ./components/guide-components/item-extras.js